import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 90000 // 90 s — Polly + S3 pueden tardar
});

/**
 * Envía la foto y los datos del formulario al servidor.
 * @param {{ nombre: string, intencion: string, foto: File, codigo?: string }} datos
 * @returns {Promise<Object>} resultado de la lectura
 */
export async function enviarLectura({ nombre, intencion, foto, codigo, mano, tipoManoCliente, ladoManoCliente }) {
  const formData = new FormData();
  formData.append('nombre', nombre);
  formData.append('intencion', intencion);
  formData.append('mano', mano || 'diestra');
  formData.append('foto', foto);
  if (codigo)           formData.append('codigo', codigo);
  if (tipoManoCliente)  formData.append('tipoManoCliente', tipoManoCliente);
  if (ladoManoCliente)  formData.append('ladoManoCliente', ladoManoCliente);

  const { data } = await api.post('/lectura', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return data;
}

export async function validarCodigoPromo(codigo) {
  const { data } = await api.post('/validar-codigo', { codigo });
  return data;
}

export default api;
